import { WeekSelectionWrapper } from './weeklyReports';
import * as XLSX from "xlsx";
import styles from './reports.module.scss';
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import { PopupOnClick } from '../../general_components/content_management/reusableItems/itemOnPopup';
const OWNER_LEASE_COLUMN_PROPORTIONS = "1fr 1.5fr 0.7fr 1.4fr 0.7fr 0.7fr 0.8fr 0.7fr 0.7fr";
const loadMoneyClass = (value) => value === 0 ? styles.grayValue : value > 0 ? styles.mainColorValue : styles.lightAlertValue;
const loadProfitAmount = (load) => (Number(load?.amountForInvoice) || 0) - (Number(load?.driverPayout) || 0);
export const ExpendedReportDetails = ({ DataEntity }) => {
    const loads = DataEntity?.loads ?? [];
    if (!loads.length) return null;
    const loadGrid = { gridTemplateColumns: OWNER_LEASE_COLUMN_PROPORTIONS };
    return (
    <div className={styles.reportLoadDetails}>
        <div className={styles.reportLoadHeader} style={loadGrid}>
            <span className={styles.reportLoadHeaderCell} style={{ gridColumn: "1 / 5" }}>Load #</span>
            <span className={styles.reportLoadHeaderCell} style={{ gridColumn: "5" }}>Rate</span>
            <span className={styles.reportLoadHeaderCell} style={{ gridColumn: "6" }}>Adjustment</span>
            <span className={styles.reportLoadHeaderCell} style={{ gridColumn: "7" }}>Payout</span>
            <span className={`${styles.reportLoadHeaderCell} ${styles.reportLoadAdjustment}`} style={{ gridColumn: "9" }}>Profit</span>
        </div>
        {loads.map((load) => {
            const profit = loadProfitAmount(load);
            return (
            <div key={load.id ?? load.loadNumber} className={styles.reportLoadRow} style={loadGrid}>
                <span className={styles.reportLoadCell} style={{ gridColumn: "1 / 5" }}><div>{load.loadNumber ? <PopupOnClick text={load.loadNumber} itemType="load" itemId={load.id} /> : '—'}</div></span>
                <span className={styles.reportLoadCell} style={{ gridColumn: "5" }}>{priceOnFinish(load.amountForInvoice ?? 0, true)}</span>
                <span className={`${styles.reportLoadCell} ${loadMoneyClass(Number(load.rateAdjustment) || 0)}`} style={{ gridColumn: "6" }}>
                    {priceOnFinish(load.rateAdjustment ?? 0, true, true)}
                </span>
                <span className={styles.reportLoadCell} style={{ gridColumn: "7" }}>{priceOnFinish(load.driverPayout ?? 0, true)}</span>
                <span className={`${styles.reportLoadCell} ${styles.reportLoadProfit} ${loadMoneyClass(profit)}`} style={{ gridColumn: "9" }}>
                    {priceOnFinish(profit, true, true)}
                </span>
            </div>
            );
        })}
    </div>
    );
};
const OWNER_LEASE_REPORT_CONF = {
    columnProportions: OWNER_LEASE_COLUMN_PROPORTIONS,
    // dataTitle: "Load",
    // dataTitlePlural:"Loads",
    // addButton:true,
    // EZCloseAllowed:false,
    
    // category: 'loads',
    clickableRow:{
        expandingComponent: ExpendedReportDetails
    },
    columns :[
        {
            label: "Truck Number",
            columnName: "truckNumber",
            conditionalFormatting: ()=>{
                return `& > * {color: var(--gray)}; font-weight:bold;}`
            }
        },
        {
            label: "Driver Name",
            columnName: "driverNames",
            customComponent:(data)=>{
                return<div key={data.truckNumber + "names"}>{data.drivers.map((driver, index)=>{
                    return <div key={"S"+index} className={styles.driverName}>{driver.driverName}</div>})}</div>
            }
        },
        {
            label: "Type",
            columnName: "truckType",
            
        },
        {
            label: "Note",
            columnName: "statementNotes",
            customComponent:(data)=>{
                if(data.statementNotes && data.statementNotes.length > 0){
                    return<div key={data.truckNumber + "notes"}>{data.statementNotes.map((note, index)=>{
                        return <div key={"D"+index} className={styles.driverName}>{note}</div>})}</div>
                }else{
                    return<div key={data.truckNumber + "notes"}></div>
                }
                
            }
        },
        {
            label: "Total Gross",
            columnName: "totalGross",
            valueGenerator: (data)=>{
                return priceOnFinish(data["totalGross"], true);
            },
            sortable: true,
            sortByRawValue: true,
            conditionalFormatting: ()=>{
                return `& > * {color: var(--gray)}; font-weight:bold;}`
            }
        },
        {
            label: "Total Rate Adjustments",
            columnName: "totalRateAdjustments",
            valueGenerator: (data)=>{
                return priceOnFinish(data["totalRateAdjustments"], true, true);
            },
            sortable: true,
            sortByRawValue: true,
            conditionalFormatting: (value)=>{
                const valueNumber = parseFloat(value.replace(/[$,]/g, ''));
                return `& > * {${valueNumber === 0 ? "color: var(--gray)" : valueNumber > 0 ? "color: var(--main-color)" : "color: var(--lightAlert)"}; font-weight:bold;}`
            },
        },
        {
            label: "Driver Payout",
            columnName: "totalDriverPayout",
            valueGenerator: (data)=>{
                return priceOnFinish(data["totalDriverPayout"], true);
            },
            sortable: true,
            sortByRawValue: true,
            conditionalFormatting: ()=>{
                return `& > * {color: var(--gray)}; font-weight:bold;}`
            }
        },
        {
            label: "Net Payout",
            columnName: "totalNetPayout",
            valueGenerator: (data)=>{
                return priceOnFinish(data["totalNetPayout"], true);
            },
            sortable: true,
            sortByRawValue: true,
            conditionalFormatting: ()=>{
                return `& > * {color: var(--gray)}; font-weight:bold;}`
            }
        },
        {
            label: "Total Profit",
            columnName: "totalProfit",
            valueGenerator: (data)=>{
                return priceOnFinish(data["totalProfit"], true, true);
            },
            sortable: true,
            sortByRawValue: true,
            conditionalFormatting: (value)=>{
                return `& > * {${parseFloat(value.replace(/[$,]/g, '')) > 0 ? "color: var(--main-color)" : "color: var(--lightAlert)"}; font-weight:900; font-size:1.1rem; padding-right:1rem;}`
            },
            alignment: "right",
        }
    ]
}
    
function ownerLeaseTableSummary(data, subdata) {
    if (!Array.isArray(data) || data.length === 0) return null;
    const totalGross = data.reduce((s, r) => s + (Number(r.totalGross) || 0), 0);
    const totalProfit = data.reduce((s, r) => s + (Number(r.totalProfit) || 0), 0);
    const totalRateAdjustments = data.reduce((s, r) => s + (Number(r.totalRateAdjustments) || 0), 0);
    const uniqueLoadNumbers = new Set();
    data.forEach(r => {
        const loads = r.loads;
        if (Array.isArray(loads)) {
            loads.forEach(load => {
                const num = typeof load === 'object' && load != null && 'loadNumber' in load
                    ? load.loadNumber
                    : load;
                if (num != null && num !== '') uniqueLoadNumbers.add(String(num));
            });
        } else {
            const n = Number(loads);
            if (!isNaN(n)) uniqueLoadNumbers.add(String(n));
        }
    });
    const loadsCompleted = uniqueLoadNumbers.size;
    const percentOfGross = (value) => {
        const amount = Number(value);
        if (!totalGross || !Number.isFinite(amount)) return null;
        const pct = Math.round((amount / totalGross) * 1000) / 10;
        return `${Number.isInteger(pct) ? pct : pct.toFixed(1)}%`;
    };
    const summaryFigure = (value, valueClassName) => {
        const share = percentOfGross(value);
        const amount = Number(value);
        const badgeClass = !Number.isFinite(amount) || amount > 0
            ? ''
            : amount === 0
                ? styles.summaryBadgeGray
                : styles.summaryBadgeAlert;
        return (
            <span className={styles.summaryValueRow}>
                <span className={`${styles.summaryValue}${valueClassName ? ` ${valueClassName}` : ''}`}>{priceOnFinish(value, true)}</span>
                {share != null ? <span className={`${styles.summaryBadge}${badgeClass ? ` ${badgeClass}` : ''}`}>{share}</span> : null}
            </span>
        );
    };
    return (
        <>
            <div className={styles.summaryBox}>
                <span className={styles.summaryLabel}>Total Gross</span>
                <span className={styles.summaryValue}>{priceOnFinish(totalGross, true)}</span>
            </div>
            <div className={styles.summaryBox}>
                <span className={styles.summaryLabel}>Total Profit</span>
                {summaryFigure(totalProfit)}
            </div>
            <div className={styles.summaryBox}>
                <span className={styles.summaryLabel}>Total Rate Adjustments</span>
                {summaryFigure(totalRateAdjustments, totalRateAdjustments === 0 ? styles.grayValue : totalRateAdjustments > 0 ? styles.mainColorValue : styles.lightAlertValue)}
            </div>
            <div className={styles.summaryBox}>
                <span className={styles.summaryLabel}>Loads Completed</span>
                <span className={styles.summaryValue}>{loadsCompleted}</span>
            </div>
            <div className={styles.summaryBox}>
                <span className={styles.summaryLabel}>Net Driver Payout</span>
                {summaryFigure(subdata)}
            </div>
        </>
    );
}

export const OwnerLeaseReportForSelectedWeek = ({companyData, department}) => {
    return <WeekSelectionWrapper companyData={companyData} reportLink={'statements/ownerLeaseReports'} predefinedListConf={OWNER_LEASE_REPORT_CONF} exportToXlsx={exportOwnerLeaseReportToXlsx} startWithPrevWeek={true} customTableSummary={ownerLeaseTableSummary} subDataKey={"totalDriversPayoutPostCharges"} allowCustomTimeframe={false} department={department} />
}

async function exportOwnerLeaseReportToXlsx(metadata, data) {
    let filename = `Rate Adjustments Report ${metadata.fileName.replace(/\//g, '.')}`;
    if (metadata.timeframe === 'monthly') {
        filename += ` ${metadata.startDate.slice(0, 4)}`;
    }
    filename += '.xlsx';
    try {
        const dataset = data ?? [];
        const summaryGross = dataset.reduce((s, r) => s + (Number(r.totalGross) || 0), 0);
        const summaryProfit = dataset.reduce((s, r) => s + (Number(r.totalProfit) || 0), 0);
        const summaryRateAdjustments = dataset.reduce((s, r) => s + (Number(r.totalRateAdjustments) || 0), 0);
        const uniqueLoadNumbers = new Set();
        dataset.forEach(r => {
            (Array.isArray(r.loads) ? r.loads : []).forEach(load => {
                const num = typeof load === 'object' && load != null && 'loadNumber' in load
                    ? load.loadNumber
                    : load;
                if (num != null && num !== '') uniqueLoadNumbers.add(String(num));
            });
        });
        const loadsCompleted = uniqueLoadNumbers.size;
        const netDriverPayout = metadata.subData != null
            ? Number(metadata.subData) || 0
            : dataset.reduce((s, r) => s + (Number(r.totalDriverPayout) || 0), 0);

        const headers = [
            "Truck Number",
            "Driver Name",
            "Type",
            "Note",
            "Total Gross",
            "Total Rate Adjustments",
            "Driver Payout",
            "Net Payout",
            "Total Profit",
            "Load Number",
            "Rate",
            "Rate Adjustment",
            "Payout",
            "Profit",
        ];

        const rows = [];

        for (const group of dataset) {
            const truck = group?.truckNumber ?? "";
            const driverName = (group?.drivers || []).map(d => d.driverName).filter(Boolean).join(", ");
            const type = group?.truckType ?? "";
            const note = Array.isArray(group?.statementNotes)
                ? group.statementNotes.filter(Boolean).join(", ")
                : (group?.statementNotes ?? "");
            const totalGross = Number(group?.totalGross) || 0;
            const driverPayout = Number(group?.totalDriverPayout) || 0;
            const netPayout = Number(group?.totalNetPayout) || 0;
            const totalRateAdjustments = Number(group?.totalRateAdjustments) || 0;
            const totalProfit = Number(group?.totalProfit) || 0;

            const loads = Array.isArray(group?.loads) && group.loads.length
                ? group.loads
                : [null];

            loads.forEach((ld, idx) => {
                const loadNum = ld?.loadNumber ?? "";
                const rate = Number(ld?.amountForInvoice) || 0;
                const rateAdjustment = Number(ld?.rateAdjustment) || 0;
                const payout = Number(ld?.driverPayout) || 0;
                const profit = rate - payout;

                const truckFields = idx === 0
                    ? [truck, driverName, type, note, totalGross, totalRateAdjustments, driverPayout, netPayout, totalProfit]
                    : ["", "", "", "", "", "", "", "", ""];

                rows.push([
                    ...truckFields,
                    loadNum,
                    ld ? rate : "",
                    ld ? rateAdjustment : "",
                    ld ? payout : "",
                    ld ? profit : "",
                ]);
            });
        }

        // Report header (title + period + summary) then column headers + data rows
        const aoa = [
            ["Rate Adjustments Report"],
            ["Period", metadata.fileName ?? ""],
            ["Total Gross", summaryGross],
            ["Total Profit", summaryProfit],
            ["Total Rate Adjustments", summaryRateAdjustments],
            ["Loads Completed", loadsCompleted],
            ["Net Driver Payout", netDriverPayout],
            [],
            headers,
            ...rows,
        ];
        const headerRowIndex = 8; // 0-based index of column headers in aoa
        const ws = XLSX.utils.aoa_to_sheet(aoa);

        ws["!cols"] = [
            { wch: 14 }, // Truck Number
            { wch: 28 }, // Driver Name
            { wch: 12 }, // Type
            { wch: 24 }, // Note
            { wch: 14 }, // Total Gross
            { wch: 22 }, // Total Rate Adjustments
            { wch: 14 }, // Driver Payout
            { wch: 14 }, // Net Payout
            { wch: 14 }, // Total Profit
            { wch: 14 }, // Load Number
            { wch: 12 }, // Rate
            { wch: 16 }, // Rate Adjustment
            { wch: 12 }, // Payout
            { wch: 12 }, // Profit
        ];
        ws["!freeze"] = { xSplit: 0, ySplit: headerRowIndex + 1, topLeftCell: `A${headerRowIndex + 2}`, activePane: "bottomLeft", state: "frozen" };

        // Summary money values (col B, rows 3-5 and 7; 1-based Excel rows → 0-based r)
        [2, 3, 4, 6].forEach(r => {
            const ref = XLSX.utils.encode_cell({ r, c: 1 });
            if (ws[ref] && typeof ws[ref].v === "number") {
                ws[ref].t = "n";
                ws[ref].z = "#,##0.00";
            }
        });

        const lastRow = aoa.length;
        const currencyCols = [4, 5, 6, 7, 8, 10, 11, 12, 13]; // Gross, Adjustments, Payout, Net, Profit, Rate, Rate Adjustment, Payout, Profit
        for (let r = headerRowIndex + 2; r <= lastRow; r++) {
            currencyCols.forEach(c => {
                const ref = XLSX.utils.encode_cell({ r: r - 1, c });
                if (ws[ref] && typeof ws[ref].v === "number") {
                    ws[ref].t = "n";
                    ws[ref].z = "#,##0.00";
                }
            });
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Rate Adjustments Report");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        await new Promise(res => setTimeout(res, 100));
        URL.revokeObjectURL(url);

        return true;
    } catch (err) {
        console.error("Failed to export Rate Adjustments Report XLSX:", err);
        return false;
    }
}